import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const RouterPush = Router.prototype.push
Router.prototype.push = function push(to){
    return RouterPush.call(this, to).catch(err => err)
}

const RouterReplace = Router.prototype.replace
Router.prototype.replace = function replace(to){
    return RouterReplace.call(this, to).catch(err => err)
}

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/work/board'
            // redirect: '/stage/store'
        },
        {
            path: '/admin-old',
            component: resolve => require(['../components/admin/common/Home.vue'], resolve),
            meta: { title: '自述文件' },
            children:[
                {
                    path: 'dashboard',
                    component: resolve => require(['../components/admin/page/old/Dashboard.vue'], resolve),
                    meta: { title: '系统首页' }
                },
                {
                    path: 'icon',
                    component: resolve => require(['../components/admin/page/old/Icon.vue'], resolve),
                    meta: { title: '自定义图标' }
                },
                {
                    path: 'table',
                    component: resolve => require(['../components/admin/page/old/BaseTable.vue'], resolve),
                    meta: { title: '基础表格' }
                },
                {
                    path: 'tabs',
                    component: resolve => require(['../components/admin/page/old/Tabs.vue'], resolve),
                    meta: { title: 'tab选项卡' }
                },
                {
                    path: 'form',
                    component: resolve => require(['../components/admin/page/old/BaseForm.vue'], resolve),
                    meta: { title: '基本表单' }
                },
                {
                    // 富文本编辑器组件
                    path: 'editor',
                    component: resolve => require(['../components/admin/page/old/VueEditor.vue'], resolve),
                    meta: { title: '富文本编辑器' }
                },
                {
                    // markdown组件
                    path: 'markdown',
                    component: resolve => require(['../components/admin/page/old/Markdown.vue'], resolve),
                    meta: { title: 'markdown编辑器' }    
                },
                {
                    // 图片上传组件
                    path: 'upload',
                    component: resolve => require(['../components/admin/page/old/Upload.vue'], resolve),
                    meta: { title: '文件上传' }   
                },
                {
                    // vue-schart组件
                    path: 'charts',
                    component: resolve => require(['../components/admin/page/old/BaseCharts.vue'], resolve),
                    meta: { title: 'schart图表' }
                },
                {
                    // 拖拽列表组件
                    path: 'drag',
                    component: resolve => require(['../components/admin/page/old/DragList.vue'], resolve),
                    meta: { title: '拖拽列表' }
                },
                {
                    // 拖拽Dialog组件
                    path: 'dialog',
                    component: resolve => require(['../components/admin/page/old/DragDialog.vue'], resolve),
                    meta: { title: '拖拽弹框' }
                },
                {
                    // 权限页面
                    path: 'permission',
                    component: resolve => require(['../components/admin/page/old/Permission.vue'], resolve),
                    meta: { title: '权限测试', permission: true }
                },
            ]
        },
        {
            path: '/admin',
            component: resolve => require(['../components/admin/common/Home.vue'], resolve),
            meta: { title: '自述文件' },
            children:[
                {
                    path: 'userTable',
                    component: resolve => require(['../components/admin/page/accountManage/UserTable.vue'], resolve),
                    meta: { title: '用户列表' }
                },
                {
                    path: 'roleTable',
                    component: resolve => require(['../components/admin/page/accountManage/RoleTable.vue'], resolve),
                    meta: { title: '角色列表' }
                },
                {
                    path: 'permissionTable',
                    component: resolve => require(['../components/admin/page/accountManage/PermissionTable.vue'], resolve),
                    meta: { title: '权限列表' }
                },
                {
                    path: 'resourceTable',
                    component: resolve => require(['../components/admin/page/accountManage/ResourceTable.vue'], resolve),
                    meta: { title: '资源列表' }
                },
                {
                    path: 'sessionTable',
                    component: resolve => require(['../components/admin/page/accountManage/SessionTable.vue'], resolve),
                    meta: { title: '会话列表' }
                },
                {
                    path: 'logTable',
                    component: resolve => require(['../components/admin/page/accountManage/LogTable.vue'], resolve),
                    meta: { title: '日志列表' }
                },
            ]
        },
        // {
        //     path: '/stage',
        //     component: resolve => require(['../components/stage/common/Home.vue'], resolve),
        //     meta: { title: '舞台' },
        //     children:[
        //         {
        //             path: 'store',
        //             component: resolve => require(['../components/stage/common/store.vue'], resolve),
        //             meta: { title: '橱窗' }
        //         },
        //         {
        //             path: 'login',
        //             component: resolve => require(['../components/stage/common/login.vue'], resolve),
        //             meta: { title: '登录页' }
        //         },
        //         {
        //             path: 'tracenote',
        //             component: resolve => require(['../components/stage/page/tracenote/tracenote.vue'], resolve),
        //             meta: { title: '日迹' }
        //         },
        //         {
        //             path: 'taskTable',
        //             component: resolve => require(['../components/stage/page/dailydiary/taskTable.vue'], resolve),
        //             meta: { title: '随记' }
        //         },
        //         {
        //             path: 'recordTable',
        //             component: resolve => require(['../components/stage/page/dailydiary/recordTable.vue'], resolve),
        //             meta: { title: '随记历史' }
        //         },
        //         {
        //             path: 'currTaskTable',
        //             component: resolve => require(['../components/stage/page/dailydiary/currTaskTable.vue'], resolve),
        //             meta: { title: '当前任务' }
        //         },
        //         {
        //             path: 'board-draw',
        //             component: resolve => require(['../components/stage/page/board/board-draw.vue'], resolve),
        //             meta: { title: '画板-绘制' }
        //         },
        //         {
        //             path: 'board-show',
        //             component: resolve => require(['../components/stage/page/board/board-show.vue'], resolve),
        //             meta: { title: '画板-展示' }
        //         },
                
        //     ]
        // },
        {
            path: '/work',
            component: resolve => require(['../components/work/common/Home.vue'], resolve),
            meta: { title: '工作' },
            children:[
                {
                    path: 'login',
                    component: resolve => require(['../components/work/common/login.vue'], resolve),
                    meta: { title: '认证-登录页' }
                },
                {
                    path: 'register',
                    component: resolve => require(['../components/work/common/register.vue'], resolve),
                    meta: { title: '认证-注册页' }
                },
                {
                    path: 'board',
                    component: resolve => require(['../components/work/page/channelAuthentication/public/board.vue'], resolve),
                    meta: { title: '认证-首页' }
                },
                {
                    path: 'writeDataFill',
                    component: resolve => require(['../components/work/page/channelAuthentication/originator/writeDataFill.vue'], resolve),
                    meta: { title: '渠道认证-基础信息填写' }
                },
                {
                    path: 'editDataFill/:id',
                    name: 'editDataFill',
                    component: resolve => require(['../components/work/page/channelAuthentication/originator/editDataFill.vue'], resolve),
                    meta: { title: '渠道认证-基础信息修改' }
                },
                {
                    path: 'seeDataFill/:id',
                    name: 'seeDataFill',
                    component: resolve => require(['../components/work/page/channelAuthentication/public/seeDataFill.vue'], resolve),
                    meta: { title: '渠道认证-基础信息查看' }
                },
                {
                    path: 'approveDataFill/:id',
                    name: 'approveDataFill',
                    component: resolve => require(['../components/work/page/channelAuthentication/approver/approveDataFill.vue'], resolve),
                    meta: { title: '渠道认证-基础信息审批' },
                },
                {
                    path: 'adminApproveDataFill/:id',
                    name: 'adminApproveDataFill',
                    component: resolve => require(['../components/work/page/channelAuthentication/admin/adminApproveDataFill.vue'], resolve),
                    meta: { title: '渠道认证-管理员基础信息审批' }
                },
                {
                    path: 'writeQuestionnaire/:id',
                    name: 'writeQuestionnaire',
                    component: resolve => require(['../components/work/page/channelAuthentication/originator/writeQuestionnaire.vue'], resolve),
                    meta: { title: '渠道认证-合规问卷填写' }
                },
                {
                    path: 'seeQuestionnaire/:id',
                    name: 'seeQuestionnaire',
                    component: resolve => require(['../components/work/page/channelAuthentication/public/seeQuestionnaire.vue'], resolve),
                    meta: { title: '渠道认证-查看合规问卷' }
                },
                {
                    path: 'approveQuestionnaire/:id',
                    name: 'approveQuestionnaire',
                    component: resolve => require(['../components/work/page/channelAuthentication/approver/approveQuestionnaire.vue'], resolve),
                    meta: { title: '渠道认证-审批合规问卷' }
                },
                {
                    path: 'adminApproveQuestionnaire/:id',
                    name: 'adminApproveQuestionnaire',
                    component: resolve => require(['../components/work/page/channelAuthentication/admin/adminApproveQuestionnaire.vue'], resolve),
                    meta: { title: '渠道认证-管理员审批合规问卷' }
                },
                {
                    path: 'writePromise/:id',
                    name: 'writePromise',
                    component: resolve => require(['../components/work/page/channelAuthentication/originator/writePromise.vue'], resolve),
                    meta: { title: '渠道认证-承诺书填写' }
                },
                {
                    path: 'seePromise/:id',
                    name: 'seePromise',
                    component: resolve => require(['../components/work/page/channelAuthentication/public/seePromise.vue'], resolve),
                    meta: { title: '渠道认证-查看承诺书' }
                },
                {
                    path: 'approvePromise/:id',
                    name: 'approvePromise',
                    component: resolve => require(['../components/work/page/channelAuthentication/approver/approvePromise.vue'], resolve),
                    meta: { title: '渠道认证-审批承诺书' }
                },
                {
                    path: 'adminApprovePromise/:id',
                    name: 'adminApprovePromise',
                    component: resolve => require(['../components/work/page/channelAuthentication/admin/adminApprovePromise.vue'], resolve),
                    meta: { title: '渠道认证-管理员审批承诺书' }
                },
                {
                    path: 'writeAgreement/:id',
                    name: 'writeAgreement',
                    component: resolve => require(['../components/work/page/channelAuthentication/originator/writeAgreement.vue'], resolve),
                    meta: { title: '渠道认证-网上协议填写' }
                },
                {
                    path: 'seeAgreement/:id',
                    name: 'seeAgreement',
                    component: resolve => require(['../components/work/page/channelAuthentication/public/seeAgreement.vue'], resolve),
                    meta: { title: '渠道认证-查看网上协议' }
                },
                {
                    path: 'approveAgreement/:id',
                    name: 'approveAgreement',
                    component: resolve => require(['../components/work/page/channelAuthentication/approver/approveAgreement.vue'], resolve),
                    meta: { title: '渠道认证-审批网上协议' }
                },
                {
                    path: 'adminApproveAgreement/:id',
                    name: 'adminApproveAgreement',
                    component: resolve => require(['../components/work/page/channelAuthentication/admin/adminApproveAgreement.vue'], resolve),
                    meta: { title: '渠道认证-管理员审批网上协议' }
                },
                {
                    path: 'originatorHome',
                    name: 'originatorHome',
                    component: resolve => require(['../components/work/page/channelAuthentication/originator/originatorHome.vue'], resolve),
                    meta: { title: '渠道认证-发起人首页' }
                },
                {
                    path: 'approverHome',
                    component: resolve => require(['../components/work/page/channelAuthentication/approver/approverHome.vue'], resolve),
                    meta: { title: '渠道认证-渠道专员' }
                },
                {
                    path: 'adminHome',
                    component: resolve => require(['../components/work/page/channelAuthentication/admin/adminHome.vue'], resolve),
                    meta: { title: '渠道认证-管理员' }
                },
                {
                    path: 'regionApproverHome',
                    component: resolve => require(['../components/work/page/channelAuthentication/approver/regionApproverHome.vue'], resolve),
                    meta: { title: '渠道认证-片区主任' }
                },
                {
                    path: 'seeNode/:id',
                    name: 'seeNode',
                    component: resolve => require(['../components/work/page/channelAuthentication/public/seeNode.vue'], resolve),
                    meta: { title: '渠道认证-节点流程' }
                },
                {
                    path: 'channel',
                    name: 'channel',
                    component: resolve => require(['../components/work/page/channelAuthentication/admin/adminChannels.vue'], resolve),
                    meta: { title: '渠道认证-渠道商查询' }
                },
                {
                    path: 'channelFirst',
                    name: 'channelFirst',
                    component: resolve => require(['../components/work/page/channelAuthentication/admin/adminChannelFirst.vue'], resolve),
                    meta: { title: '渠道认证-一代创建' }
                },
                {
                    path: 'writeDataFill_Service',
                    component: resolve => require(['../components/work/page/channelAuthentication/originator/writeDataFill_Service.vue'], resolve),
                    meta: { title: '服务认证-基础信息填写' }
                },
                {
                    path: 'editDataFill_Service/:id',
                    name: 'editDataFill_Service',
                    component: resolve => require(['../components/work/page/channelAuthentication/originator/editDataFill_Service.vue'], resolve),
                    meta: { title: '服务认证-基础信息修改' }
                },
                {
                    path: 'seeDataFill_Service/:id',
                    name: 'seeDataFill_Service',
                    component: resolve => require(['../components/work/page/channelAuthentication/public/seeDataFill_Service.vue'], resolve),
                    meta: { title: '服务认证-基础信息查看' }
                },
                {
                    path: 'approveDataFill_Service/:id',
                    name: 'approveDataFill_Service',
                    component: resolve => require(['../components/work/page/channelAuthentication/approver/approveDataFill_Service.vue'], resolve),
                    meta: { title: '服务认证-基础信息审批' },
                },
                {
                    path: 'approverHome_Service',
                    component: resolve => require(['../components/work/page/channelAuthentication/approver/approverHome_Service.vue'], resolve),
                    meta: { title: '服务认证-审批者首页' }
                },
                {
                    path: 'originatorHome_Service',
                    name: 'originatorHome_Service',
                    component: resolve => require(['../components/work/page/channelAuthentication/originator/originatorHome_Service.vue'], resolve),
                    meta: { title: '服务认证-发起人首页' }
                },
                {
                    path: 'adminHome_Service',
                    name: 'adminHome_Service',
                    component: resolve => require(['../components/work/page/channelAuthentication/originator/adminHome_Service.vue'], resolve),
                    meta: { title: '服务认证-渠道商查询' }
                },
                {
                    path: 'ucsa_Service',
                    name: 'ucsa_Service',
                    component: resolve => require(['../components/work/page/ucsa/ucsa_Service.vue'], resolve),
                    meta: { title: '服务认证-UCSA证书信息管理' }
                },
                {
                    path: 'ucsa_Company',
                    name: 'ucsa_Company',
                    component: resolve => require(['../components/work/page/ucsa/ucsa_Company.vue'], resolve),
                    meta: { title: '服务认证-UCSA证书信息(公司)' }
                },
                {
                    path: 'isv_docment',
                    component: resolve => require(['../components/work/page/isvAuthentication/isvAuthenticationManage.vue'], resolve),
                    meta: { title: 'ISV认证管理-管理员首页' }
                },
                {
                    path: 'showIsvDataFill/:id',
                    name: 'showIsvDataFill',
                    component: resolve => require(['../components/work/page/isvAuthentication/showIsvDataFill.vue'], resolve),
                    meta: { title: 'ISV-信息查看' }
                },
                {
                    path: 'ucsaCertificate',
                    name: 'ucsaCertificate',
                    component: resolve => require(['../components/work/page/serviceAuthentication/ucsaCertificate.vue'], resolve),
                    meta: { title: 'UCSA证书查询' }
                },
                {
                    path: 'test',
                    name: 'test',
                    component: resolve => require(['../components/work/page/test/test.vue'], resolve),
                    meta: { title: '测试用的页面' }
                }
            ]
        },
        {
            path: '/404',
            component: resolve => require(['../components/common/404.vue'], resolve),
            meta: { title: '404' }
        },
        {
            path: '/403',
            component: resolve => require(['../components/common/403.vue'], resolve),
            meta: { title: '403' }
        },
        {
            path: '/unAuthorized',
            component: resolve => require(['../components/common/UnAuthorized.vue'], resolve),
            meta: { title: 'unAuthorized' }
        }
    ]
})
